import { render, staticRenderFns } from "./AppointmentType.vue?vue&type=template&id=95d625da&scoped=true&"
import script from "./AppointmentType.vue?vue&type=script&lang=js&"
export * from "./AppointmentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d625da",
  null
  
)

export default component.exports